function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.800000012
}, /*#__PURE__*/React.createElement("g", {
  id: "TopNav/Desktop",
  transform: "translate(-765.000000, -39.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(236.000000, 29.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "more-horizontal",
  transform: "translate(529.000000, 10.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 9,
  cy: 2,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 16,
  cy: 2,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 2,
  cy: 2,
  r: 2
}))))));

var SvgMoreHorizontal = function SvgMoreHorizontal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "4px",
    viewBox: "0 0 18 4",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoreHorizontal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/more-horizontal.b6265b59.svg";
export { ForwardRef as ReactComponent };